export default {
    common: {

    },
    page: {
        allFormat: 'Formatting process runs only in your browser',
        addCode: 'Add your JSON',
        formatterStory:{
            title: 'IN ONE TOOL',
            one: 'multilevel tree view',
            two: 'string to JSON converter',
            three: ''
        }
    }
}
